import { defineComponent as n, openBlock as o, createBlock as d, unref as m, withCtx as r, renderSlot as a } from "vue";
import s from "./ghl-ui.es171.js";
const f = n({
  name: "UICollapseItem",
  inheritAttrs: !1
}), u = n({
  ...f,
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["onItemHeaderClick"],
  setup(t) {
    return (e, l) => (o(), d(m(s), {
      id: t.id,
      title: t.title,
      name: t.name,
      onOnItemHeaderClick: l[0] || (l[0] = (i) => e.$emit("onItemHeaderClick", i))
    }, {
      header: r(() => [
        a(e.$slots, "header")
      ]),
      "header-extra": r(() => [
        a(e.$slots, "header-extra")
      ]),
      default: r(() => [
        a(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "title", "name"]));
  }
}), I = u;
export {
  I as default
};
